import Instance from '../https';
import { getApiEnumUrl, getApiUrl } from '../';
import { DrugSearchData, PatientPostRequest, AddPatientMedication } from '../requests';
import {
   DrugSearchResponse,
   DrugSearchResponseData,
   GetDrugDetailsResponse,
   PatientMedicationsResponse,
   ProviderMedicationsResponse,
} from '../requests/response';

export const getPatients: any = (
   controller: string,
   PageNumber: number,
   PageSize = 10,
   searchData: Record<string, any>,
) => {
   const searchParams: Record<string, any> = {
      PageNumber,
      PageSize,
      ...searchData,
   };

   const queries = Object.keys(searchParams).reduce((prev, current) => {
      if (!searchParams[current]) {
         return prev + '';
      }

      if (!prev) {
         return prev + `?${current}=${searchParams[current]}`;
      }

      return prev + `&${current}=${searchParams[current]}`;
   }, '');

   return Instance.get(`${getApiUrl(controller)}${queries}`);
};

export const createPatients: any = (controller: string, payload: PatientPostRequest) => {
   return Instance.post(getApiUrl(controller), payload);
};

export const getPatientDetails: any = (controller: string, id: string) => {
   return Instance.get(`${getApiUrl(controller)}/${id}`);
};

export const getPatientAddition: any = (controller: string, id: string) => {
   return Instance.get(`${getApiUrl(controller)}/${id}/additionalinformation`);
};

export const getPatientEmployer: any = (controller: string, id: string) => {
   return Instance.get(`${getApiUrl(controller)}/${id}/employers`);
};

export const getPatientInsurance: any = (controller: string, id: string) => {
   return Instance.get(`${getApiUrl(controller)}/${id}/insurances`);
};

export const getPatientEmergency: any = (controller: string, id: string) => {
   return Instance.get(`${getApiUrl(controller)}/${id}/emergencycontacts`);
};

export const editPatientDetails: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.put(`${getApiUrl(controller)}/${id}`, payload);
};

export const updatePatientBasic: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/information`, payload);
};

export const updatePatientContact: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/contact`, payload);
};

export const updatePatientAll: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/identitycards`, payload);
};

export const updatePatientAddition: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/additionalinformation`, payload);
};

export const updatePatientEmployer: any = (
   controller: string,
   id: string,
   RegId: string,
   payload: Record<string, any>,
) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/employers/${RegId}`, payload);
};

export const updatePatientInsurance: any = (
   controller: string,
   id: string,
   RegId: string,
   payload: Record<string, any>,
) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/insurances/${RegId}`, payload);
};

export const updatePatientInsuranceRole: any = (
   controller: string,
   id: string,
   RegId: string,
   payload: Record<string, any>,
) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/insurances/${RegId}/role`, payload);
};

export const updatePatientIdentity: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/identitycards`, payload);
};

export const updatePatientEmergency: any = (
   controller: string,
   id: string,
   RegId: string,
   payload: Record<string, any>,
) => {
   return Instance.put(`${getApiUrl(controller)}/${id}/emergencycontacts/${RegId}`, payload);
};

export const addPatientEmployer: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.post(`${getApiUrl(controller)}/${id}/employers`, payload);
};

export const addPatientInsurance: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.post(`${getApiUrl(controller)}/${id}/insurances`, payload);
};

export const addPatientEmergency: any = (controller: string, id: string, payload: Record<string, any>) => {
   return Instance.post(`${getApiUrl(controller)}/${id}/emergencycontacts`, payload);
};

export const getPatientMedication: any = (
   controller: string,
   id: string,
   PageNumber: number,
   PageSize = 10,
   searchData: Record<string, any>,
   action: string,
) => {
   const searchParams: Record<string, any> = {
      PageNumber,
      PageSize,
      ...searchData,
   };

   const queries = Object.keys(searchParams).reduce((prev, current) => {
      if (!searchParams[current]) {
         return prev + '';
      }

      if (!prev) {
         return prev + `?${current}=${searchParams[current]}`;
      }

      return prev + `&${current}=${searchParams[current]}`;
   }, '');

   return Instance.get(`${getApiEnumUrl(controller, id, action)}${queries}`);
};

export const addPatientPharmacy: any = (
   controller: string,
   id: string,
   directory: string,
   body: Record<string, any>,
) => {
   return Instance.post(getApiEnumUrl(controller, id, directory), body);
};

export const getMedication: any = (controller: string, patientId: string, directory: string, medId: string) => {
   return Instance.get(`${getApiEnumUrl(controller, patientId, directory)}/${medId}`);
};

export const addMedication: any = (controller: string, id: string, payload: Record<string, any>) => {
   const url = `/${id}/medications`;
   return Instance.post(`${getApiUrl(controller)}${url}`, payload);
};

export const getPharmacies: any = (controller: string, id: string, directory: string) => {
   return Instance.get(getApiEnumUrl(controller, id, directory));
};

export const getGender: any = (controller: string, action: string) => {
   const url = `genders`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getGender2: any = (controller: string, action: string) => {
   const url = `patientgenders`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getMaritalStatus: any = (controller: string, action: string) => {
   const url = `maritalstatuses`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getNameSuffix: any = (controller: string, action: string) => {
   const url = `namesuffixes`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getNamePrefix: any = (controller: string, action: string) => {
   const url = `nameprefixes`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getIDTypes: any = (controller: string, action: string) => {
   const url = `id-types`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
}; ///emrapi/v1/systems/lookup/enhanced-id-types

export const getIDTypesEnhanced: any = (controller: string, action: string) => {
   const url = `enhanced-id-types`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getPatientLookups: any = (controller: string, action: string) => {
   const url = `patient-lookups`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getProviders: any = (controller: string, action: string) => {
   const url = `providers`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getRefProviders: any = (controller: string, action: string) => {
   const url = `ref-providers`;
   return Instance.get(`${getApiUrl(controller, action)}${url}`);
};

export const getPatientCurrentMedications: any = (controller: string, id: string, action: string): Promise<any> => {
   const url = `/${id}/${action}`;
   return Instance.get<PatientMedicationsResponse>(`${getApiUrl(controller)}${url}`);
};

export const getProviderMedication: any = (controller: string, action: string): Promise<any> => {
   return Instance.get<ProviderMedicationsResponse>(`${getApiUrl(controller, action)}`);
};

export const getDrugSearchResult: any = (
   controller: string,
   action: string,
   searchData: DrugSearchData,
): Promise<any> => {
   const url = `?DrugFilter=${searchData.SearchFilter.Id}&SearchWord=${searchData.Search}`;
   return Instance.get<DrugSearchResponse>(`${getApiUrl(controller, action)}${url}`);
};

export const getDrugDetailsRequest = (
   controller: string,
   action: string,
   drugInfo: DrugSearchResponseData,
): Promise<any> => {
   const url = `details?packageId=${drugInfo.PackageId}&productId=${drugInfo.ProductId}`;
   return Instance.get<GetDrugDetailsResponse>(`${getApiUrl(controller, action)}${url}`);
};

export const getDrugDetailsRequest2 = (
   controller: string,
   action: string,
   drugInfo: DrugSearchResponseData,
): Promise<any> => {
   const url = `?packageId=${drugInfo.PackageId}`;
   return Instance.get<GetDrugDetailsResponse>(`${getApiEnumUrl(controller, action, drugInfo.ProductId)}/${url}`);
};

export const addPatientMedication = (
   controller: string,
   id: string,
   payload: AddPatientMedication | any,
): Promise<any> => {
   const url = `/${id}/medications`;
   return Instance.post<AddPatientMedication>(`${getApiUrl(controller)}${url}`, payload);
};

export const deletePatientMedication: any = (controller: string, id: string, medicationId: string) => {
   const url = `/${id}/medications/${medicationId}`;
   return Instance.delete(`${getApiUrl(controller)}${url}`);
};

export const LinkPharmacyPatient = (
   controller: string,
   directory: string,
   entity: string,
   payload: Record<string, any>,
): Promise<any> => {
   return Instance.patch(`${getApiUrl(controller, directory)}${entity}`, payload);
};

export const createVitalSigns = (controller: string, patientId: string, payload: Record<string, any>): Promise<any> => {
   const url = `${controller}/${patientId}/vitalsigns`;
   //return url;
   return Instance.post(url, payload);
};

export const updateVitalSigns = (
   controller: string,
   patientId: string,
   vitalId: number,
   payload: Record<string, any>,
): Promise<any> => {
   const url = `${controller}/${patientId}/vitalsigns/${vitalId}`;
   //return url;
   return Instance.put(url, payload);
};

export const GetVitalSigns = (
   controller: string,
   patientId: string,
   PageNumber?: number,
   PageSize?: number,
): Promise<any> => {
   //DateFrom, DateTo, PageNumber, PageSize
   PageNumber = PageNumber ? PageNumber : 1;
   PageSize = PageSize ? PageSize : 15;
   const url = `${controller}/${patientId}/vitalsigns?PageNumber=${PageNumber}&PageSize=${PageSize}`;
   //return url;
   return Instance.get(url);
};

export const GetVitalSign = (controller: string, patientId: string, vitalId: number): Promise<any> => {
   const url = `${controller}/${patientId}/vitalsigns/${vitalId}`;
   //return url;
   return Instance.get(url);
};

export const DeleteVitalSign = (controller: string, patientId: string, vitalId: number): Promise<any> => {
   const url = `${controller}/${patientId}/vitalsigns/${vitalId}`;
   //return url;
   return Instance.delete(url);
};

//get patient encounters
export const getEncounterNotes = (
   controller: string = 'charts',
   action: string = 'patientcharts',
   patientId: string,
   PageNumber?: number,
   PageSize = 10,
   searchData?: Record<string, any>,
) => {
   const searchParams: Record<string, any> = {
      PageNumber,
      PageSize,
      ...searchData,
   };

   const queries = Object.keys(searchParams).reduce((prev, current) => {
      if (!searchParams[current]) {
         return prev + '';
      }

      if (!prev) {
         return prev + `?${current}=${searchParams[current]}`;
      }

      return prev + `&${current}=${searchParams[current]}`;
   }, '');

   return Instance.get(`${getApiUrl(controller, action)}${patientId}/encounters${queries}`);
};

export const GetEncounterNote = (
   controller: string = 'charts',
   action: string = 'patientcharts',
   patientId: string,
   noteId: string,
): Promise<any> => {
   //DateFrom, DateTo, PageNumber, PageSize
   // const url = `${controller}/${patientId}/vitalsigns?PageNumber=${PageNumber}&PageSize=${PageSize}`;
   ///emrapi/v1/charts/patientcharts/{chartNo}/encounters/{encounterId}/noteview
   //return url;
   return Instance.get(`${getApiUrl(controller, action)}${patientId}/encounters/${noteId}/noteview`);
};

export const GetDuplicatePatinet = (
   controller: string = 'patients',
   action: string = 'duplicates',
   lastname: string,
   gender: string,
   dob: string,
): Promise<any> => {
   //DateFrom, DateTo, PageNumber, PageSize
   // const url = `${controller}/${patientId}/vitalsigns?PageNumber=${PageNumber}&PageSize=${PageSize}`;
   ///emrapi/v1/charts/patientcharts/{chartNo}/encounters/{encounterId}/noteview
   //return url;
   return Instance.get(`${controller}/${action}?lastname=${lastname}&gender=${gender}&DateOfBirth=${dob}`);
};
